<template>
	<Modal ref="addToCalendarModal" :centerButtons="true" data-testid="addToCalendarModalTitle" ariaLabelled="addToCalendarModalTitle">
		<template #title>Add to Calendar</template>
		<template #default>
			<p>Classes and times are subject to change.</p>
		</template>
		<template #footer>
			<button type="button" class="btn btn-primary" data-testid="modalAddToCalendarBtn" @click="addToCalendar('ics')">Add to Calendar</button>
			<button type="button" class="btn btn-primary" data-testid="modalAddToGoogleCalendarBtn" @click="addToCalendar('google')">Add to Google Calendar</button>
		</template>
	</Modal>
</template>

<script>
import { defineComponent } from 'vue';
import Modal from '@/components/schreg-common/Modal.vue';
import { StateService } from '@/services/state.service';
import { EdgeApi } from '@/apis/edge.api';

export default defineComponent({
	name: 'AddToCalendar',
	components: {
		Modal
	},
	data() {
		return {
			eventId: null,
			registrationId: null,
			isSpaReservation: false,
			reservationDate: null
		};
	},
	mounted() {

	},
	methods: {
		open(eventId, registrationId, isSpaReservation, reservationDate) {
			this.eventId = eventId;
			this.registrationId = registrationId;
			this.isSpaReservation = isSpaReservation;
			this.reservationDate = reservationDate;
			this.$refs.addToCalendarModal.show();
		},
		close() {
			this.$refs.addToCalendarModal.hide();
		},
		addToCalendar(calType) {
			const params = {
				eventId: this.eventId,
				registrationId: this.registrationId,
				isSpaReservation: this.isSpaReservation,
				reservationDate: this.reservationDate,
				type: calType,
				'subscription-key': StateService.getApimKey(),
				'ssoid': StateService.getSSOToken()
			};
			const url = EdgeApi.addToCalendar(params);
			if (calType === 'google') {
				window.open(url, '_blank');
			} else {
				window.location.href = url;
			}
			this.close();
		}
	}
});
</script>
